import { render, staticRenderFns } from "./ViewMsg.vue?vue&type=template&id=7ba1e392&"
import script from "./ViewMsg.vue?vue&type=script&lang=js&"
export * from "./ViewMsg.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/view_msg.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports